import { render } from "./FormTabs.vue?vue&type=template&id=7eb0ce44"
import script from "./FormTabs.vue?vue&type=script&lang=js"
export * from "./FormTabs.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__